export default "__VITE_ASSET__D1yYCm36__"